// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__naRjI","header":"ReportDetails_header__3oret","title":"ReportDetails_title__2d7P2","left":"ReportDetails_left__C_er0"};